import { createFileRoute } from "@tanstack/react-router";
import { BidResourcesPage } from "@client/components/ss-bid-gen/bid-resources-page";

/** 标书生成租户资源库管理页（仅租户管理员；后端 @RequiresTenantAdm 兜底鉴权） */
export const Route = createFileRoute("/_app/ss-bid-gen/resources")({
  component: BidResources,
});

function BidResources() {
  return (
    <div className="h-full min-h-0">
      <BidResourcesPage />
    </div>
  );
}
